import { ColumnCtaProps } from '@ahc-digital/component-library';
import { useConditionalRendering } from 'src/shared/useConditionalRendering';
import { getDroplink } from '@/shared/param-utils';
import { C05MulticolumnCTAProps } from './C05MulticolumnCTA.types';

export function CreateMultiColumnCTAModel(props?: C05MulticolumnCTAProps) {
  type t = ColumnCtaProps;
  const { renderRichText, renderText, renderLink } = useConditionalRendering();
  const { params, fields } = props || {};

  return {
    contentAlignment: getDroplink<t['contentAlignment']>(params?.ContentAlignment, 'left'),
    cta: renderLink(fields?.CTA),
    headline: renderText(fields?.Headline),
    headlineTag: getDroplink<t['headlineTag']>(params?.HeadlineTag, 'p'),
    supportCopy: renderRichText(fields?.SupportCopy),
  };
}
